import React from "react";

function Divider() {

    return <div>
        <hr className="thin" />
    </div>
}

export default React.memo(Divider);